import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import type { Breadcrumb } from '@/types/shared'
import { Form } from './components/Form'

type PrefectureOption = {
  code: number
  name: string
}

type AdminSchoolEditProps = {
  school: {
    id: string
    name: string | null
    prefectureId: number | null
    league: string | null
  }
  options: {
    prefectures: PrefectureOption[]
  }
  breadcrumbs: Breadcrumb[]
}

export default function Edit({ school, options, breadcrumbs }: AdminSchoolEditProps) {
  return (
    <AppShell>
      <Head title={`高校編集｜${school.name ?? '未設定'}`} />
      <PageHeader
        title="高校編集"
        description="登録済み高校の情報を更新します。"
        breadcrumbs={breadcrumbs}
      />
      <Form values={school} prefectures={options.prefectures} mode="edit" />
    </AppShell>
  )
}
